import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import type { Locale } from '@/helpers/locale-helper';

import { editorialLocales, isEditorialLocale } from '@/routing/editorial';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { buildUrlForDomain, Domain } from '@/routing/helpers/subdomain-helper';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

import SmartLink from '@/components/nav/links/SmartLink.vue';

type EditorialLocale = {
	country: string;
	webLocale: string;
	flag: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideLanding',
  setup(__props) {

const { locales, webLocale } = storeToRefs(useLanguageStore());

const linkComponent = computed(() => {
	return isEditorialLocale(webLocale.value)
		? {
				cmp: SmartLink,
				attrs: {
					to: { name: 'app.editorial.subdomain.home' },
				},
		  }
		: {
				cmp: 'a',
				attrs: {
					href: '/us',
				},
		  };
});

const filteredLocales = computed(() =>
	locales.value.filter((locale: Locale) => editorialLocales.includes(locale.webLocale))
);

const editorialLocalesList = computed(() => {
	let localesArr: EditorialLocale[] = [];

	filteredLocales.value.map((locale: Locale) => {
		localesArr.push({
			country: locale.iso_3166_2,
			webLocale: locale.webLocale,
			flag: `${JW_CONFIG.ASSETS_URL}/flags/${locale.webLocale.toUpperCase()}.png`,
		});
	});

	return localesArr;
});

const currentLocale = computed(() => {
	return (
		editorialLocalesList.value.find(locale => locale.webLocale === webLocale.value) ??
		editorialLocalesList.value.find(locale => locale.webLocale === 'us')
	);
});

const displayedLocaleList = computed(() => {
	return editorialLocalesList.value.filter(locale => locale.webLocale !== currentLocale.value?.webLocale);
});

function getGuideHomeUrl(targetLocale: string) {
	const path = `/${targetLocale}`;
	return buildUrlForDomain(path, Domain.EDITORIAL);
}

return { __sfc: true,locales, webLocale, linkComponent, filteredLocales, editorialLocalesList, currentLocale, displayedLocaleList, getGuideHomeUrl, faChevronRight }
}

})